import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";
import type { Vacancy } from "../types/VacancyTypes";

export const QUERY_KEY = "getVacancy";

interface GetVacancyParams {
  locale?: string;
}

export const useGetVacancy = (
  slug: string | undefined,
  params?: GetVacancyParams
) => {
  return useQuery({
    queryKey: [QUERY_KEY, slug, params],
    queryFn: async (): Promise<Vacancy> => {
      if (!slug) {
        throw new Error("Vacancy slug is required");
      }
      const response = await apiClient.get<Vacancy>(
        API_ROUTES.vacancy(slug),
        {
          headers: {
            "Content-Type": "application/json",
          },
          params,
        }
      );
      return response.data;
    },
    enabled: !!slug,
  });
};
